import React, { useContext, useEffect, useRef } from 'react';
import { ErrorContext } from '../lib/ErrorContext';
import InputContainer from './InputContainer';

type TextInputProps = Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    'onChange'
> & {
    id?: string; // Optional id for the input
    className?: string; // Optional class name for styling
    label?: string;
    onChange: (value: string) => void; // Function to handle change in input value
    inputClassName?: string;
    inlineEditable?: boolean;
    error?: string;
};
const TextInput = ({
    value,
    onChange,
    autoFocus,
    className,
    label,
    id,
    inputClassName,
    type,
    inlineEditable,
    placeholder,
    error,
    ...restInputProps
}: TextInputProps) => {
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (autoFocus) {
            setTimeout(() => {
                inputRef.current?.focus();
            }, 100);
        }
    }, [autoFocus]);

    return (
        <InputContainer
            className={className}
            label={label}
            id={id}
            error={error}
        >
            <input
                ref={inputRef}
                type={type || 'text'}
                value={value || ''}
                className={`${inputClassName} ${inlineEditable ? '!bg-transparent hover:!bg-gray-300 focus:!bg-white' : ''}`}
                placeholder={
                    placeholder || (inlineEditable ? 'None' : undefined)
                }
                autoFocus={autoFocus}
                onChange={e => onChange && onChange(e.target.value)}
                {...restInputProps}
            />
        </InputContainer>
    );
};

export default TextInput;
